import { render, staticRenderFns } from "./Currency.vue?vue&type=template&id=69834271&"
import script from "./Currency.js?vue&type=script&lang=js&"
export * from "./Currency.js?vue&type=script&lang=js&"
import style0 from "./Currency.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports